import { useState } from 'react';

import LetterShell from 'components/Patient/checkin/SecurePayment/components/Letter/LetterShell';

import useLivePreviewToggle from '../../../../lib/useLivePreviewToggle';

import LivePreviewHeader from './components/LivePreviewHeader';
import LivePreviewTabs from './components/LivePreviewTabs';
import { LIVE_PREVIEW_TAB_KEYS } from './lib/helpers';

const LivePreview = ({ draft, activePhaseField }) => {
  const [activeKey, setActiveKey] = useState(draft.letter_type);

  const isLivePreviewVisible = useLivePreviewToggle();

  if (!isLivePreviewVisible) return null;

  const view = activeKey === LIVE_PREVIEW_TAB_KEYS.PRE_AUTH_FORM ? activeKey : draft.letter_type;

  return (
    <LetterShell
      view={view}
      mode="preview"
      config={draft}
      activePhaseField={activePhaseField}
      topSlot={
        <>
          <LivePreviewHeader />
          <LivePreviewTabs
            activeKey={activeKey}
            setActiveKey={setActiveKey}
            letterType={draft.letter_type}
          />
        </>
      }
    />
  );
};

export default LivePreview;
